export const GET_ALL_CATEGORIES_WITH_PRODUCTS_REQUEST =
  " GET_ALL_CATEGORIES_WITH_PRODUCTS_REQUEST";
export const GET_ALL_CATEGORIES_WITH_PRODUCTS_SUCCESS =
  " GET_ALL_CATEGORIES_WITH_PRODUCTS_SUCCESS";
export const GET_ALL_CATEGORIES_WITH_PRODUCTS_FAILURE =
  " GET_ALL_CATEGORIES_WITH_PRODUCTS_FAILURE";
